// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NotificationContainer_WorkflowTrackerFragment = { __typename?: 'WorkflowTracker', id: string, status: Types.WorkflowTrackerStatus, kind: Types.WorkflowTrackerKind, failureReason?: string | null, householdID?: string | null, createdAt: Time, updatedAt: Time, startedAt: Time, endedAt?: Time | null, description?: string | null, entities?: Array<{ __typename?: 'Entity', id: string }> | null, memos: { __typename?: 'MemoConnection', edges?: Array<{ __typename?: 'MemoEdge', node?: { __typename?: 'Memo', id: string } | null } | null> | null }, household?: { __typename?: 'Household', id: string, displayName: string } | null, presentation?: { __typename?: 'ClientPresentationV2', id: string } | null, documents?: Array<{ __typename?: 'Document', id: string, type: Types.DocumentType }> | null, documentSummaryPromptTestRun?: { __typename?: 'DocumentSummaryPromptTestRun', id: string, documentSummaryPrompt?: { __typename?: 'DocumentSummaryPrompt', id: string } | null } | null };

export type FetchCurrentUserWorkflowTrackerHistoryQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  kinds?: Types.InputMaybe<Array<Types.WorkflowTrackerKind> | Types.WorkflowTrackerKind>;
}>;


export type FetchCurrentUserWorkflowTrackerHistoryQuery = { __typename?: 'Query', currentUserWorkflowTrackerHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & NotificationContainer_WorkflowTrackerFragment
      ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } };

export type DismissAllWorkflowTrackersMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DismissAllWorkflowTrackersMutation = { __typename?: 'Mutation', dismissAllWorkflowTrackers: number };

export type CurrentUserWorkflowTrackerUpdatesSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserWorkflowTrackerUpdatesSubscription = { __typename?: 'Subscription', currentUserWorkflowTrackerUpdates: (
    { __typename?: 'WorkflowTracker' }
    & NotificationContainer_WorkflowTrackerFragment
  ) };

export const Operations = {
  Query: {
    FetchCurrentUserWorkflowTrackerHistory: 'FetchCurrentUserWorkflowTrackerHistory' as const
  },
  Mutation: {
    DismissAllWorkflowTrackers: 'DismissAllWorkflowTrackers' as const
  },
  Subscription: {
    CurrentUserWorkflowTrackerUpdates: 'CurrentUserWorkflowTrackerUpdates' as const
  },
  Fragment: {
    NotificationContainer_WorkflowTracker: 'NotificationContainer_WorkflowTracker' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const NotificationContainer_WorkflowTrackerFragmentDoc = gql`
    fragment NotificationContainer_WorkflowTracker on WorkflowTracker {
  id
  status
  kind
  failureReason
  householdID
  createdAt
  updatedAt
  startedAt
  endedAt
  description
  entities {
    id
  }
  memos {
    edges {
      node {
        id
      }
    }
  }
  household {
    id
    displayName
  }
  presentation {
    id
  }
  documents {
    id
    type
  }
  documentSummaryPromptTestRun {
    id
    documentSummaryPrompt {
      id
    }
  }
}
    `;
export const FetchCurrentUserWorkflowTrackerHistoryDocument = gql`
    query FetchCurrentUserWorkflowTrackerHistory($first: Int!, $after: Cursor, $kinds: [WorkflowTrackerKind!]) {
  currentUserWorkflowTrackerHistory(
    first: $first
    after: $after
    filter: {kinds: $kinds}
  ) {
    edges {
      node {
        ...NotificationContainer_WorkflowTracker
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NotificationContainer_WorkflowTrackerFragmentDoc}`;

/**
 * __useFetchCurrentUserWorkflowTrackerHistoryQuery__
 *
 * To run a query within a React component, call `useFetchCurrentUserWorkflowTrackerHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentUserWorkflowTrackerHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentUserWorkflowTrackerHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useFetchCurrentUserWorkflowTrackerHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>(FetchCurrentUserWorkflowTrackerHistoryDocument, withFetchPolicyContext(options));
      }
export function useFetchCurrentUserWorkflowTrackerHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>(FetchCurrentUserWorkflowTrackerHistoryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchCurrentUserWorkflowTrackerHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>(FetchCurrentUserWorkflowTrackerHistoryDocument, withFetchPolicyContext(options));
        }
export type FetchCurrentUserWorkflowTrackerHistoryQueryHookResult = ReturnType<typeof useFetchCurrentUserWorkflowTrackerHistoryQuery>;
export type FetchCurrentUserWorkflowTrackerHistoryLazyQueryHookResult = ReturnType<typeof useFetchCurrentUserWorkflowTrackerHistoryLazyQuery>;
export type FetchCurrentUserWorkflowTrackerHistorySuspenseQueryHookResult = ReturnType<typeof useFetchCurrentUserWorkflowTrackerHistorySuspenseQuery>;
export type FetchCurrentUserWorkflowTrackerHistoryQueryResult = Apollo.QueryResult<FetchCurrentUserWorkflowTrackerHistoryQuery, FetchCurrentUserWorkflowTrackerHistoryQueryVariables>;
export const DismissAllWorkflowTrackersDocument = gql`
    mutation DismissAllWorkflowTrackers {
  dismissAllWorkflowTrackers
}
    `;
export type DismissAllWorkflowTrackersMutationFn = Apollo.MutationFunction<DismissAllWorkflowTrackersMutation, DismissAllWorkflowTrackersMutationVariables>;

/**
 * __useDismissAllWorkflowTrackersMutation__
 *
 * To run a mutation, you first call `useDismissAllWorkflowTrackersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAllWorkflowTrackersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAllWorkflowTrackersMutation, { data, loading, error }] = useDismissAllWorkflowTrackersMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissAllWorkflowTrackersMutation(baseOptions?: Apollo.MutationHookOptions<DismissAllWorkflowTrackersMutation, DismissAllWorkflowTrackersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAllWorkflowTrackersMutation, DismissAllWorkflowTrackersMutationVariables>(DismissAllWorkflowTrackersDocument, options);
      }
export type DismissAllWorkflowTrackersMutationHookResult = ReturnType<typeof useDismissAllWorkflowTrackersMutation>;
export type DismissAllWorkflowTrackersMutationResult = Apollo.MutationResult<DismissAllWorkflowTrackersMutation>;
export type DismissAllWorkflowTrackersMutationOptions = Apollo.BaseMutationOptions<DismissAllWorkflowTrackersMutation, DismissAllWorkflowTrackersMutationVariables>;
export const CurrentUserWorkflowTrackerUpdatesDocument = gql`
    subscription CurrentUserWorkflowTrackerUpdates {
  currentUserWorkflowTrackerUpdates {
    ...NotificationContainer_WorkflowTracker
  }
}
    ${NotificationContainer_WorkflowTrackerFragmentDoc}`;

/**
 * __useCurrentUserWorkflowTrackerUpdatesSubscription__
 *
 * To run a query within a React component, call `useCurrentUserWorkflowTrackerUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWorkflowTrackerUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWorkflowTrackerUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWorkflowTrackerUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CurrentUserWorkflowTrackerUpdatesSubscription, CurrentUserWorkflowTrackerUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CurrentUserWorkflowTrackerUpdatesSubscription, CurrentUserWorkflowTrackerUpdatesSubscriptionVariables>(CurrentUserWorkflowTrackerUpdatesDocument, withSubscriptionIgnoreResults(options));
      }
export type CurrentUserWorkflowTrackerUpdatesSubscriptionHookResult = ReturnType<typeof useCurrentUserWorkflowTrackerUpdatesSubscription>;
export type CurrentUserWorkflowTrackerUpdatesSubscriptionResult = Apollo.SubscriptionResult<CurrentUserWorkflowTrackerUpdatesSubscription>;